export const Office = {
    office: null,
    offices: []
}